'use strict';

import {reverseUrl} from 'utils/django';


export default {
	method: 'POST',
	getUrl: getUrl,
};


function getUrl($incident) {
	return 'incident/' + $incident.uuid + '/daupler/incidents/calls/tasks/generic_form_team/request/';
}
